import React, { Component } from 'react';
import Dashboard from './SideBar/dashboard';
import Landing from './../landing/containers/LandingContainer';


class HocDashboard extends Component {
  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <Dashboard history={this.props.history} />
      </Landing>
    );
  }
}

export default HocDashboard;